module.exports = __webpack_public_path__ + "static/media/logo.ff1c0394.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar/logo.svg
// module id = 315
// module chunks = 0